'use strict';

angular.module('docketbook').
  controller('paywalledController', function ($scope, $state, billingService, accessControl) {

    const currentOrg = accessControl.currentOrg();

    $scope.trialButtonClick = function () {
      mixpanel.track("Start trial");
      billingService.updateOrganisationBilling(
        currentOrg.id, {
        plan: currentOrg.currentPlanId,
        features_trial: true,
      },
        function () {
          /*$scope.$parent.showTrialActivatedModal(function() {
              window.location.reload();
          })*/
          $('#trialActivatedModal').fadeIn(100)
        },
        function (err) {
          swal({
            title: "Oops!",
            text: "Sorry, something went wrong.  Please contact Docketbook support",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        }
      )
    }
  })



// WEBPACK FOOTER //
// ./src/controllers/paywall/paywalledController.js